import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import { BrowserRouter } from "react-router-dom";


import './Assets/Fonts/Questrial/Questrial-Regular.ttf';
import './Assets/Fonts/Microgramma/Microgramma D Extended Bold.otf';
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
reportWebVitals();
